import { defineComponent as s, useSlots as r, openBlock as a, createBlock as i, unref as o, mergeProps as l, createSlots as u, withCtx as f, renderSlot as m } from "vue";
import p from "./ghl-ui.es365.js";
const d = s({
  name: "UISpin",
  inheritAttrs: !1
}), c = s({
  ...d,
  props: {
    size: {
      type: [String, Number],
      default: "medium"
    },
    show: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const n = r();
    return (t, h) => (a(), i(o(p), l(t.$attrs, {
      show: e.show,
      size: e.size
    }), u({ _: 2 }, [
      o(n).default ? {
        name: "default",
        fn: f(() => [
          m(t.$slots, "default")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["show", "size"]));
  }
}), _ = c;
export {
  _ as default
};
